export enum TradeRequestWorkflowVariations {
  tradeRequestRebalance = 'Trade Request - Rebalance',
  tradeRequestFlatten = 'Trade Request - Flatten',
  tradeRequestSpecificSecurities = 'Trade Request - Specific Securities',
  tradeRequestSwap = 'Trade Request - Swap'
}
